module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_96-5349e73b1650d83bd1b4c5af56d673f9.png";